export default {
  baseApiUrl: 'https://62.171.161.5:8080',
  wsUrl: 'ws://62.171.161.5:8082',
  googleMapsApiKey: 'AIzaSyB5dMhcHUv7gml_79A2hyjCwiNYnP4kbdQ'
}
